/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.Header';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the Header!',
  },
  user: {
    id: `${scope}.header.user`,
    defaultMessage: 'Hi {name}',
  },
  upgradeMessage: {
    id: `${scope}.upgradeMessage`,
    defaultMessage: 'upgrade now for full access!',
  },
  upgradeMessageSale: {
    id: `${scope}.upgradeMessageSale`,
    defaultMessage: 'Sale Time! Get 40% Off - Limited Offer',
  },
  logout: {
    id: `${scope}.header.logout`,
    defaultMessage: 'Log out',
  },
  login: {
    id: `${scope}.header.login`,
    defaultMessage: 'Log in',
  },
  upgradeButton: {
    id: `${scope}.header.upgradeButton`,
    defaultMessage: 'Upgrade',
  },
  upgradeButtonSale: {
    id: `${scope}.header.upgradeButtonSale`,
    defaultMessage: 'Save Now',
  },
  myProfile: {
    id: `${scope}.header.myProfile`,
    defaultMessage: 'My Profile',
  },
  myFolders: {
    id: `${scope}.header.myFolders`,
    defaultMessage: 'My folders',
  },
  myCollection: {
    id: `${scope}.header.myCollection`,
    defaultMessage: 'My Collection',
  },
  myFavorites: {
    id: `${scope}.header.myFavorites`,
    defaultMessage: 'My favorites',
  },
  languages: {
    id: `${scope}.header.languages`,
    defaultMessage: 'Languages',
  },
  strength: {
    id: `${scope}.header.strength`,
    defaultMessage: 'strength',
  },
  posture: {
    id: `${scope}.header.posture`,
    defaultMessage: 'posture',
  },
  anatomy: {
    id: `${scope}.header.anatomy`,
    defaultMessage: 'anatomy',
  },
  yoga: {
    id: `${scope}.header.yoga`,
    defaultMessage: 'yoga',
  },
  useMsg: {
    id: `${scope}.header.useMsg`,
    defaultMessage: 'You currently use:',
  },
  title: {
    id: `${scope}.msg.title`,
    defaultMessage: 'Dear {name},',
  },
  description1: {
    id: `${scope}.msg.description1`,
    defaultMessage: 'This drop-down menu enables you to navigate between our different products: ',
  },
  description2: {
    id: `${scope}.msg.description2`,
    defaultMessage: 'Strength Training, Anatomy, Posture and Yoga.',
  },
  description3: {
    id: `${scope}.msg.description3`,
    defaultMessage: 'For example, if you are subscribed to our Anatomy product, choose Anatomy.',
  },
  description4: {
    id: `${scope}.msg.description4`,
    defaultMessage:
      'If you are subscribed to Strength Training, Posture or Yoga products, the Anatomy content already embedded.',
  },
  description5: {
    id: `${scope}.msg.description5`,
    defaultMessage: 'You can find the Anatomy content at the main menu to the left of the screen.',
  },
  description6: {
    id: `${scope}.msg.description6`,
    defaultMessage: 'The relevant chapters are "Muscular Anatomy" and "Kinesiology & Skeletal".',
  },
  description7: {
    id: `${scope}.msg.description7`,
    defaultMessage:
      'If you are subscribed to Posture, please note that you have also the Yoga product content already embedded.',
  },
  description8: {
    id: `${scope}.msg.description8`,
    defaultMessage: 'You can find the Yoga content at the main menu to the left of the screen.',
  },
  description9: {
    id: `${scope}.msg.description9`,
    defaultMessage:
      'The relevant content is under "Yoga Asanas" chapter and also in some of the sub-chapters under "Therapeutic Exercises".',
  },
  description10: {
    id: `${scope}.msg.description10`,
    defaultMessage: 'Enjoy,',
  },
  description11: {
    id: `${scope}.msg.description11`,
    defaultMessage: 'Muscle & Motion Team',
  },
  guest: {
    id: `${scope}.guest`,
    defaultMessage: 'Guest',
  },
});
